import Image from 'next/image';
import { CDN_BASE_URL } from './constants';
const Why = () => <section className="fl-mb-12/24 relative py-[100px] md:py-[120px] xl:py-[132px] 2xl:py-[152px]" data-sentry-component="Why" data-sentry-source-file="Why.tsx">
    <Image alt="" className="absolute top-1/2! left-1/2! z-0 h-[calc(100%+200px)]! w-screen -translate-x-1/2 -translate-y-1/2 object-cover md:h-[calc(100%+100px)]!" fill sizes="100vw" src={`${CDN_BASE_URL}/rae_waveform.png`} data-sentry-element="Image" data-sentry-source-file="Why.tsx" />
    <div className="special-page-container mx:container relative z-1">
      <h2 className="fl-text-2xl/3xl fl-mb-4/8 text-pretty text-left font-semibold text-gray-950">
        Why join?
      </h2>
      <p className="block max-w-[800px] text-pretty font-sans text-base text-gray-950 tracking-tightest md:text-lg md:tracking-tightest 2xl:text-xl 2xl:tracking-tightest">
        Uppbeat's mission is to empower creators everywhere.
        <br />
        <br />
        Whether you're new to content creation or a pro, become a partner and
        you'll unlock ways to earn from your audience. Plus we'll help you grow
        your channel with incredible creative assets, as well as personalized
        support, exclusive assets, sponsorship opportunities and more.
      </p>
    </div>
  </section>;
export default Why;